/* ON LOCK — PRE-PURCHASE UPSELL logic.
   Intercepts the Secure Checkout click in our own cart drawer, offers a
   size-matched add, then continues to /checkout.

   DESIGN NOTES (read before changing):
   - NO live AI call in this path. The customer just clicked checkout; an LLM
     round-trip would put a spinner in the highest-intent second of the session.
     Offers are rules over data we already hold. AI's job is offline: refreshing
     the rules and writing copy variants to test.
   - SIZE MATCH is the edge an app can't have. We read the sizes already in the
     cart and only show sizes we can actually ship, pre-selecting theirs.
   - EVERY customer sees this screen. There is no hold-out (Joel 5 Aug: "we
     shouldn't have a control group, bro, I want everyone to see it"). Sessions
     are still bucketed A/B and the bucket rides onto the ORDER as a cart
     attribute, so copy or offer variants can be tested later at no cost — but
     both buckets are shown the screen.
*/
(function(){
  var root=document.getElementById('olUpsell');
  if(!root || !window.OL_UPSELL_OFFERS) return;

  var CFG={
    /* ⛔ OFF — Joel 1 Aug. Two reasons, both his and both right:
       1. Without a discount the tiles don't ENTICE. "Unlocks free shipping" doesn't move
          someone who'd have bought the shorts anyway. The discount IS the offer.
       2. On a $340 cart every tier is already unlocked, so unlockedBy() returned null for
          every product and the screen showed nothing useful — the tier-unlock framing has
          no pitch at all for the customers who matter most.
       ON since 3 Aug 2026 — both objections are now answered. Every tile carries a real
       discount honoured by a single-use code minted at the moment of acceptance, and the
       free beanie moved to a $0 product so it no longer eats the one product-discount slot
       Shopify allows. Verified live: a $418 cart took the $0 beanie, $36.40 of upsell
       discount and $38.16 of 10% together, paying $343.44 at checkout. */
    enabled: true,
    /* NO ITEM DISCOUNTS — deliberate, and load-bearing.
       Tipping a near-threshold cart over $180 with a CHEAP item LOSES money: a $169 cart
       plus $16 socks pays $166.50 after the 10%, i.e. less than they were already spending,
       and you ship an extra unit (~-$6 profit). Break-even is a $109 cart; every near-miss
       cart is $120-180. Tipping it with the $94 SHORTS instead is ~+$37, because the tier
       discount is small relative to the item added.
       So the shorts lead, the offer is the unlock, and nothing here is marked down. */
    /* Spec lines are VERBATIM phrases from each product's own Shopify description — the
       hardware/fabric detail is what makes them read premium (Joel 30 Jul: "that's what
       makes them gangster"). NEVER write new product claims here; pull them from the product. */
    blurbByHandle:{
      'monolith-tee-black-ft-pink':    ['100% Luxury Heavyweight Cotton — 280gsm','Perfected oversized drop shoulder fit','Crisp embroidered front logo'],
      'monolith-tee-blood-red':        ['100% Luxury Heavyweight Cotton — 280gsm','Perfected oversized drop shoulder fit','Big statement back piece — fabric panels + vintage flash stitching'],
      'fall-rise-tee-oat':             ['100% Luxury Heavyweight Cotton — 280gsm','Perfected oversized drop shoulder fit','Subtle embroidered front logo'],
      'initial-shorts-soft-white':     ['100% Luxury Cotton, 280gsm','Full custom metal hardware','Custom zip pockets'],
      'initial-shorts-black-ft-cream': ['100% Luxury Cotton, 280gsm','Full custom metal hardware','Custom zip pockets'],
      'initial-socks-white':           ['85% Combed Cotton, soft AF','Fit enhancer','Jacquard knitted branding'],
      'initial-socks-3pk-white':       ['3 pairs','85% Combed Cotton, soft AF','Jacquard knitted branding'],
      /* added 20 Aug with the three tees. VERBATIM from each product's own description —
         every tile must carry bullets or none of them should, Joel 20 Aug: "you've got to be
         consistent, all products with dot points or not." */
      'consistency-tee-pitch-black':   ['100% Luxury Heavyweight Cotton — 280gsm','Perfected oversized drop shoulder fit','Consistency Essential Traits embroidered back piece'],
      'consistency-tee-charcoal':      ['100% Luxury Heavyweight Cotton — 280gsm','Perfected oversized drop shoulder fit','Premium DTG gradient print'],
      'monolith-tee-black-ft-arctic-blue': ['100% Luxury Heavyweight Cotton — 280gsm','Perfected oversized drop shoulder fit','Big statement back piece — fabric panels + vintage flash stitching'],
      'initial-cargos-black':              ['97% Premium Cotton 3% Spandex for Stretch, 210gsm','Full custom metal hardware','Custom zip pockets']
    },
    /* Where the single-use code is minted. The worker owns the amounts; these numbers are
       for DISPLAY ONLY and must mirror OFFER_PRICING in chatbot/worker/upsell-discount.js.
       If the two ever disagree the customer is charged the worker's number, so change both. */
    codeEndpoint: 'https://onlock-support-chat.joel-d32.workers.dev/upsell/code',
    /* EVERY tile on this screen carries a discount. Joel 3 Aug: "there is nothing that
       should be full price in the fucking cart" — it is an offer screen, so a full-price
       tile is just a product ad and has no reason to be here.
       Socks at 25/30 leave $8.55 and $16.25 respectively, which reconciles exactly to the
       basket analysis already recorded in onlock-preupsell.liquid. The 3PK stays the better
       buy at 2.2x the price for 3x the pairs, so the ladder still pulls upward. */
    /* THE PRICE TEST — $35 OFF (A) vs $25 OFF (B), 21 Sep 2026. Only rules with test:true
       move; socks keep their percentage in both buckets (Joel 21 Sep), so do sweatpants.
       CENTS here, DOLLARS in the worker. Mirrors TEST_AMOUNT in upsell-discount.js. */
    /* 🔚 28 Sep 2026: test closed, Joel chose $25. Both buckets $25 (worker mirrored FIRST). */
    testAmounts:{A:2500,B:2500},
    offerPricing:{
      'monolith-tee-black-ft-pink':        {amountOff:3500,test:true},
      'monolith-tee-blood-red':            {amountOff:3500,test:true},   /* 21 Sep, Joel. Mirrored in the worker in the same change. */
      /* 28 Sep, Joel: the two best sellers, never on screen before. Worker mirrored FIRST. $25 via testAmounts. */
      'monolith-tee-tiffany':              {amountOff:3500,test:true},
      'monolith-tee-black-onblack':        {amountOff:3500,test:true},
      'fall-rise-tee-oat':                 {amountOff:3500,test:true},
      /* the three deep-cover tees, added 20 Aug. Consistency PB 55wks, Charcoal 44wks,
         Black ft Blue 31wks of cover — this screen is where they move. $40 off a $100
         tee = $60, still 57-66% margin on real landed cost. Joel's call 20 Aug. */
      'consistency-tee-pitch-black':       {amountOff:3500,test:true},
      /* cargos in 23 Aug — Consistency Pitch Black took ZERO in 4 days on screen while
         cargos sit on 190 units doing nothing. $40 off $158 = $118, still $79/unit. */
      'initial-cargos-black':              {amountOff:3500,test:true},
      'consistency-tee-charcoal':          {amountOff:3500,test:true},
      'monolith-tee-marle-grey':           {amountOff:3500,test:true},  /* 5 Oct: last spare in the tile test. Worker mirrored FIRST. */
      'monolith-tee-black-ft-arctic-blue': {amountOff:3500,test:true},  /* handle says arctic-blue, product reads 'Black ft. Blue' */  /* -> $76, same as the other tee */  /* -> $76, EXACTLY the PDP
                                                            'Cop 2 Tees' 2nd-tee price. Same number
                                                            everywhere or the bundle looks like a lie. */
      'initial-sweatpants-cloud-grey':     {amountOff:3000},
      'initial-sweatpants-black-ft-cream': {amountOff:3000},
      'initial-shorts-soft-white':     {amountOff:3500,test:true},
      'initial-shorts-black-ft-cream': {amountOff:3500,test:true},  /* Joel 20 Aug: matched to the tees. $94 -> $54, still 66% margin. */
      'initial-socks-white':           {pctOff:25},
      'initial-socks-3pk-white':       {pctOff:30},
      /* 28 Sep 2026: Lil Lock socks priced in advance (worker mirrored FIRST). Swap the tile in the liquid offerHandles when they go ACTIVE. */
      'lil-lock-socks-3pk-white':      {pctOff:30},
      'lil-lock-socks-3pk-black':      {pctOff:30}
    },
    maxCards: 4,
    /* 🧪 TILE TEST — BEFORE vs NOW, both $25 off (Joel 5 Oct 2026, "set it all up and get it all cranking").
       A = the 24-28 Sep screen that took ~25% of screens (Black ft Blue, Black ft Pink, Blood Red).
       B = the 28 Sep screen that took ~11% (Tiffany, Black on Black, Blood Red).
       Each bucket's list is ranked: the first teeSlots tees that pass the filters show, the rest are
       SPARES that step in when a tee is already in the cart or sold out in their size, so the screen
       is ALWAYS teeSlots tees + the extras (Joel: "it should always show 4"). Read it with
       node scripts/upsell-metrics.js — judged on shirt profit per screen from 5 Oct. */
    teeSlots: 3,
    tileOrder: {
      A: ['monolith-tee-black-ft-arctic-blue','monolith-tee-black-ft-pink','monolith-tee-blood-red',
          'monolith-tee-black-onblack','monolith-tee-tiffany','monolith-tee-marle-grey'],
      B: ['monolith-tee-tiffany','monolith-tee-black-onblack','monolith-tee-blood-red',
          'monolith-tee-black-ft-arctic-blue','monolith-tee-black-ft-pink','monolith-tee-marle-grey']
    },
    extraTiles: ['lil-lock-socks-3pk-white'],
    /* only pitch to carts already worth pitching to; below this the screen is
       friction with no upside */
    minCartCents: 8000,
    /* Show the screen ONCE per browsing session. Without this, hitting back from checkout
       re-fires it every single time — declining is an answer, asking again is nagging, and
       that is how a pre-purchase upsell quietly costs you the order it was meant to grow.
       Flip to false to A/B the nag against the single ask. */
    /* How long to stay quiet after they've been shown the screen once.
       Was permanent-for-the-tab, which cost impressions: someone who comes back to their
       cart 20 minutes later never gets offered again. 5 minutes still kills the thing we
       actually care about — backing out, removing the item and re-adding it cheaper —
       because that loop happens in seconds. Set 0 to show every time. (Joel 30 Jul) */
    seenTtlMinutes: 5,
    /* OFF — Joel's call 30 Jul. Filtering on PAST orders is wrong for apparel: someone who
       bought white shorts a year ago has worn them out, and a discount is exactly what brings
       them back for the same pair. Only the CURRENT cart should suppress an offer.
       Plumbing kept (window.OL_UPSELL_OWNED) in case we ever want it for a specific product. */
    hidePreviouslyPurchased: false
  };

  var OFFERS=window.OL_UPSELL_OFFERS||[];
  /* mirrors the cart drawer's tiers — pre-discount basis, gift excluded */
  var TIERS=[{label:'10% OFF',cents:18000},{label:'FREE SHIPPING',cents:22500},{label:'FREE GIFT',cents:28900}];
  /* $0 gift product since 3 Aug 2026 — see the note in onlock-cart-drawer.js. The legacy
     $48 variant stays listed so a pre-cutover cart still excludes it from tier maths. */
  /* every $0 gift variant + the retired $48 one — all excluded from tier maths so a free
     item can never count toward the spend that earned it */
  var GIFT_VARIANTS=[67684284432497,44026194067569,44318532862065,43857620107377,43860299186289,43114752573553];   /* black = live gift again 17 Sep 2026 */

  /* ── MULTI-CURRENCY (7 Sep 2026) ─────────────────────────────────────────
     Shopify Markets serves /cart.js in the LOCAL presentment currency. Every tier
     here is denominated in the SHOP currency (AUD). Without this, an NZ cart of
     NZ$289 would clear the A$289 gift tier and every reward — free hat included —
     would unlock for roughly 8-9% less real money.
     Shopify.currency.rate is "1.0" on the AU storefront, so FX === 1 and this is a
     mathematical NO-OP today. It only starts acting when a local currency is on.
     RULE: eligibleCents() returns SHOP-currency cents, so every tier comparison
     below keeps working untouched. To DISPLAY a shop-currency amount use moneyAud();
     money() is for values that already came out of the cart in local currency. */
  var FX = (function(){
    try { var r = parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate);
          return (isFinite(r) && r > 0) ? r : 1; } catch(e){ return 1; }
  })();
  function toLocal(auCents){ return Math.round(auCents * FX); }
  function toShop(localCents){ return Math.round(localCents / FX); }
  /* NZ FREE SHIPPING AT NZ$200 (Joel 26 Sep 2026: "whatever converts to 200 AUD, 200 NZ").
     The NZ delivery zone's free rate is TOTAL_PRICE >= A$157 (NZ prices round UP ~2-3% over
     the FX rate, so A$157 is what a NZ$200 cart is worth either way). Below A$180 there is no
     10% so the goods gate is the rate gate. If either number moves, move BOTH. */
  if (window.Shopify && window.Shopify.country === 'NZ') {
    TIERS.forEach(function(t){ if (t.label === 'FREE SHIPPING') { t.cents = 15700; t.showLocal = 20000; } });
    TIERS.sort(function(a,b){ return a.cents - b.cents; });
  }
  function eligibleCents(cart){
    /* SHOP currency — see the FX note above. dropUnearnedGift() and every tier test
       depend on this being the same currency as TIERS. */
    var t=0; cart.items.forEach(function(it){ if(GIFT_VARIANTS.indexOf(it.variant_id)===-1) t+=it.original_line_price; });
    return toShop(t);
  }
  /* THE UPSELL DISCOUNT IS INVISIBLE TO THE CART. It is applied by /discount/CODE on the way
     to checkout, AFTER every gift decision has been made. So at go() the cart still shows the
     upsold tee at full price, goods read $300, and the hat looks earned — while the customer
     is about to pay $238.50. That is exactly #8627 (11 Sep 2026), and 10 more like it since
     1 Sep. So work out what they will ACTUALLY pay and gate the gift on that.
     The automatic 10% is recalculated on the reduced subtotal once the code lands, so the
     upsell discount is scaled by the cart's current discount ratio — that reproduces #8627
     to the cent: 27000 - 3500 x 0.9 = 23850. */
  var GIFT_PAID_FLOOR = 26000;   /* matches GIFTS[].paid in onlock-cart-drawer.js */
  function upsellOffCents(){
    if(!offerCode) return 0;      /* no code minted = nothing comes off at checkout */
    var t=0;
    Object.keys(added).forEach(function(h){
      var o=OFFERS.filter(function(x){ return x.handle===h; })[0];
      if(o) t+=offerOff(h,o.price);
    });
    return t;
  }
  function paidAfterUpsell(cart){
    var now=toShop(cart.total_price), orig=toShop(cart.original_total_price)||0;
    var ratio = orig>0 ? now/orig : 1;
    return now - Math.round(upsellOffCents()*ratio);
  }
  function nextTier(cents){ return TIERS.filter(function(t){ return cents<t.cents; })[0]||null; }
  /* What this add is actually WORTH toward a tier — price minus whatever comes off it.
     Proven live 2026-08-03: a $100 tee + $94 shorts at $25 off is a $194 basket that pays
     $169, and $169 does not clear the $180 tier. Measuring tier progress on the full price
     would promise an unlock the customer then does not get. */
  function netAdd(cart,o){ return o.price - liveOff(cart,o); }
  /* what does adding this product newly unlock? drives the badge + the whole pitch */
  function unlockedBy(cart,price){
    var before=eligibleCents(cart), after=before+price;
    var got=TIERS.filter(function(t){ return before<t.cents && after>=t.cents; });
    return got.length? got[got.length-1] : null;   /* headline the biggest one crossed */
  }
  var grid=document.getElementById('olUpsellGrid');
  var sub=document.getElementById('olUpsellSub');
  var goTxt=document.getElementById('olUpsellGoTxt');
  var added={};              /* handle -> variantId */
  /* Every tap still in the air. Checkout MUST wait on these or a tap made a moment before
     "Continue" is lost: go() reads `added` at that instant, the add lands after we have already
     navigated, and the customer paid without the item. 8 taps went that way 20 Jul-14 Aug
     (#7887 #7888 #7912 #7934 #7943 #7947 #7953 #7962); #7889 and #7973 got the item but were
     tagged "not taken", which is the same race seen from the other side.
     REGISTERED AT THE TOP OF doAdd, NOT after the mint. The mint is a network call of its own,
     so registering after it leaves the whole mint window unprotected. Caught in testing. */
  var inFlight=[];
  var proceeding=false;
  var offerCode=null;        /* the minted single-use code, once we hold one */
  var offerNodeId=null;      /* its Shopify node id, so a re-mint can retire it */
  var cartToken=null;        /* /cart.js token — lets the SERVER retire codes this cart already holds */

  /* 🚨 offerNodeId LIVES ONLY AS LONG AS THE PAGE. Tap → reload → tap minted a SECOND live
     code that replaced nothing, and both applied: #8756 took $70 off $200 (17 Sep 2026).
     The authoritative fix is server-side — the worker retires every unused code tagged with
     this cart token before it mints. This is the cheap local half: remember the node id
     against the cart so an ordinary reload still knows what it is replacing. Never rely on
     it alone; localStorage can be empty or throw in a private window. */
  function nodeKey(){ return cartToken ? 'ol_upsell_node_'+String(cartToken).replace(/[^A-Za-z0-9]/g,'').slice(0,24) : null; }
  function rememberNode(id){ try{ var k=nodeKey(); if(k){ id ? localStorage.setItem(k,id) : localStorage.removeItem(k); } }catch(e){} }
  function recallNode(){ try{ var k=nodeKey(); return k ? localStorage.getItem(k) : null; }catch(e){ return null; } }

  /* The rule for this handle AS THIS SESSION SEES IT. A `test:true` rule takes its dollars
     from the A/B bucket — that is the whole price test. Everything else is bucket-blind.
     One place, so the tile, the label and the mint request can never disagree. */
  function ruleFor(handle){
    var r=CFG.offerPricing[handle];
    if(!r) return null;
    if(!r.test) return r;
    var amt=CFG.testAmounts[bucket()];
    return {amountOff: amt!=null ? amt : CFG.testAmounts.A};
  }
  /* what comes off this product, in cents. Display only — the worker re-prices server-side. */
  function offerOff(handle,price){
    var r=ruleFor(handle);
    if(!r) return 0;
    var off = r.amountOff!=null ? r.amountOff : Math.round(price*r.pctOff/100);
    return Math.min(off,price);
  }
  /* SAY THE BIGGER NUMBER. Joel 3 Aug on the socks: "you've written save $4. That doesn't
     sound like anything... that should be 25%, because it's a bigger number."
     $4 off $16 is nothing to look at; 25% is. Conversely $30 off sweatpants beats "26% off".
     The rule falls straight out of how each offer is configured — percentage offers say the
     percentage, dollar offers say the dollars — so there is nothing extra to keep in sync. */
  function offerLabel(handle,price){
    var r=ruleFor(handle);
    if(!r) return '';
    return r.amountOff!=null ? money(r.amountOff) : r.pctOff+'%';
  }

  /* There WAS a gift-tier guard here. History, so nobody re-adds it:
     while the free beanie was a $48 item zeroed by the FREE BEANIE OVER $260 automatic
     discount, it occupied the single product-discount slot Shopify allows, and our upsell
     code silently died on any cart over $260. The guard hid offers there so we never
     promised a price we could not honour.
     That cause is GONE. The beanie is now a $0 product and uses no discount at all, proven
     live on a $418 cart taking the $0 beanie, $36.40 of upsell discount and $38.16 of 10%
     together. Leaving the guard in place cost a real sale: Joel's own $306 test cart had
     every offer filtered out and the screen never opened.
     Keep this comment. Only restore a guard here if the beanie ever goes back to being a
     discount. */
  function liveOff(cart,o){ return offerOff(o.handle,o.price); }

  /* Mint (or re-mint) the code covering EVERY offer accepted so far.
     Re-mint matters: a customer who takes a second offer must not be left holding a code
     that only covers the first. Resolves to null on any failure — every caller treats that
     as "do not promise a price we cannot honour". */
  /* The cart as it stood when this screen OPENED, in dollars, gifts excluded. The server
     turns this into the minimum spend the minted code requires, so a customer cannot accept
     an offer and then delete the rest of the basket out from under a live discount — which
     is how #8256 walked off with a $100 tee for $60 and nothing attached.
     Captured at open, NOT read live, because by the second tap the cart already contains the
     first accepted item and reading it again would count that item twice. */
  var openBaseDollars = 0;

  function mintCode(handles){
    return fetch(CFG.codeEndpoint,{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({handles:handles, replaces:offerNodeId||recallNode(), cartToken:cartToken,
                           baseSubtotal:openBaseDollars, bucket:bucket()})})
      .then(function(r){ return r.ok? r.json() : null; })
      .then(function(d){
        if(!d || !d.code) return null;
        offerCode=d.code; offerNodeId=d.nodeId||null; rememberNode(offerNodeId);
        return d;
      })
      .catch(function(){ return null; });
  }

  function money(c){ var n=c/100; return '$'+(n%1===0? n.toFixed(0): n.toFixed(2)); }
  /* SHOP-currency amounts (tiers, offer pricing) rendered in what the shopper sees */
  function moneyAud(c){ return money(toLocal(c)); }

  /* ---- A/B bucketing -------------------------------------------------- */
  /* NO HOLD-OUT — Joel 5 Aug: "we shouldn't have a control group, bro... I want everyone
     to see it." Bucket C used to see nothing so we could measure lift; that meant a third of
     paying customers were deliberately shown no offer, which is a real cost to satisfy a
     measurement. His call, and it's his money.
     A/B is KEPT because it costs nothing and leaves the door open to testing copy or offers
     later — both buckets see the screen, they're just labelled. Anyone still carrying a
     stored 'C' from before is migrated, or they'd never see the screen again. */
  function bucket(){
    try{
      var b=localStorage.getItem('ol_upsell_bucket');
      if(!b || b==='C'){ b=['A','B'][Math.floor(Math.random()*2)]; localStorage.setItem('ol_upsell_bucket',b); }
      return b;
    }catch(e){ return 'A'; }
  }
  /* Underscore prefix keeps these hidden from the customer, but they still land on the ORDER,
     which is what makes the whole experiment readable from the Orders API with no third-party
     analytics. _upsell_why records the path taken (shown / no-offers-left / ...) so
     "nobody took it" can be told apart from "it never appeared". */
  /* TAPS AND FAILURES. 30 customers saw the screen and none completed a take — which is
     either "nobody wants it" or "the button is broken for them", and those need completely
     different fixes. Nothing distinguished them: a tap that fails to mint leaves no trace
     anywhere, and the /upsell/code endpoint has died twice already.
     `_upsell_taps` = how many tiles they actually pressed. `_upsell_fail` = why the last one
     didn't stick. Zero taps means it's a persuasion problem. Taps with failures means it's
     broken and every one of those customers saw "Offer unavailable". */
  var tapCount=0, lastFail='';
  function tagCart(b,took,why){
    var attrs={'_upsell_bucket':b,'_upsell_taken':took?'yes':'no'};
    if(why) attrs['_upsell_why']=why;
    if(tapCount) attrs['_upsell_taps']=String(tapCount);
    if(lastFail) attrs['_upsell_fail']=lastFail;
    return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({attributes:attrs})
    }).catch(function(){});
  }

  /* ---- size matching -------------------------------------------------- */
  var SIZE_ORDER=['XS','S','M','L','XL','XXL','2XL'];
  function cartSizes(cart){
    var seen={};
    cart.items.forEach(function(it){
      var v=(it.variant_title||'').split('/')[0].trim().toUpperCase();
      if(v && SIZE_ORDER.indexOf(v)>-1) seen[v]=(seen[v]||0)+it.quantity;
    });
    /* most-bought size in the cart wins */
    return Object.keys(seen).sort(function(a,b){return seen[b]-seen[a];})[0]||null;
  }

  function inStock(o){ return o.variants.filter(function(v){ return v.available && v.qty>0; }); }

  var OWNED=(window.OL_UPSELL_OWNED||[]).reduce(function(m,h){ m[h]=1; return m; },{});

  function pickOffers(cart){
    var inCart={};
    cart.items.forEach(function(it){ if(it.handle) inCart[it.handle]=1; });
    var size=cartSizes(cart);
    var byH={}; OFFERS.forEach(function(o){ byH[o.handle]=o; });
    function ok(o){
      if(!o || inCart[o.handle]) return false;                                /* never pitch what they already have */
      if(CFG.hidePreviouslyPurchased && OWNED[o.handle]) return false;
      var vs=inStock(o); if(!vs.length) return false;                          /* never pitch a dead product */
      /* sized product + we know their size + that size is gone -> let a spare step in instead */
      var sized=o.variants.some(function(v){ return SIZE_ORDER.indexOf(String(v.size).toUpperCase())>-1; });
      if(sized && size && !vs.some(function(v){ return String(v.size).toUpperCase()===size; })) return false;
      /* DROP anything we cannot actually discount (Joel 3 Aug: nothing on this screen is full price).
         Above ~$260 nothing survives and the screen is skipped via the no-offers-left path. */
      return liveOff(cart,o) > 0;
    }
    var order=CFG.tileOrder[bucket()]||CFG.tileOrder.A;
    var tees=order.map(function(h){ return byH[h]; }).filter(ok).slice(0,CFG.teeSlots);
    var extras=CFG.extraTiles.map(function(h){ return byH[h]; }).filter(ok);
    return tees.concat(extras).slice(0,CFG.maxCards);
  }

  /* seen-this-session gate. sessionStorage, so it clears when they close the tab but
     survives back-navigation from checkout — which is exactly the case we're guarding. */
  var SEEN_KEY='ol_upsell_seen';
  function alreadySeen(){
    if(!CFG.seenTtlMinutes) return false;
    try{
      var ts=parseInt(sessionStorage.getItem(SEEN_KEY),10);
      if(!ts) return false;                                   /* also clears the old '1' value */
      if((Date.now()-ts)/60000 >= CFG.seenTtlMinutes){ sessionStorage.removeItem(SEEN_KEY); return false; }
      return true;
    }catch(e){ return false; }
  }
  function markSeen(){ try{ sessionStorage.setItem(SEEN_KEY,String(Date.now())); }catch(e){} }

  /* ---- test hatch -----------------------------------------------------------------
     ?olupsell=reset   clear the seen-gate AND the A/B bucket
     ?olupsell=A|B|C   force a bucket (C = hold-out, sees no screen at all)
     &olclear=1        empty the cart too
     Params are stripped from the URL afterwards so a refresh doesn't re-fire them.
     Harmless in production: it only ever resets a customer's own local state. */
  (function testHatch(){
    var q, v, clear;
    try{ q=new URLSearchParams(location.search); }catch(e){ return; }
    v=q.get('olupsell'); clear=q.get('olclear');
    if(!v && !clear) return;
    try{
      if(v==='reset'){ sessionStorage.removeItem(SEEN_KEY); localStorage.removeItem('ol_upsell_bucket'); }
      else if(v && /^[abc]$/i.test(v)){ sessionStorage.removeItem(SEEN_KEY); localStorage.setItem('ol_upsell_bucket', v.toUpperCase()); }
    }catch(e){}
    var strip=function(){
      try{
        q.delete('olupsell'); q.delete('olclear');
        var s=q.toString();
        history.replaceState({}, '', location.pathname + (s?'?'+s:'') + location.hash);
      }catch(e){}
    };
    console.log('[OL upsell] reset applied. bucket =', (function(){try{return localStorage.getItem('ol_upsell_bucket')||'(none, will randomise)';}catch(e){return '?';}})());
    if(clear==='1'){ fetch('/cart/clear.js',{method:'POST'}).then(function(){ strip(); location.reload(); }); }
    else strip();
  })();

  /* ---- render --------------------------------------------------------- */
  /* returns {price, off, badge} — off is the saving in cents, 0 when full price */
  /* No markdowns. The badge sells what ADDING this unlocks — real, already-live rewards. */
  function card(o,match,cart,idx){
    var vs=inStock(o);
    var isOneSize = vs.length===1 && /default/i.test(vs[0].size);
    var specs=[]; /* Joel 15 Oct 2026: no fabric bullets on upsell tiles ('get rid of those... save heaps of space'). Blurbs kept in CFG in case. */
    var blurb=specs.length
      ? '<ul class="olu-card__specs">'+specs.map(function(s){return '<li>'+s+'</li>';}).join('')+'</ul>'
      : '';
    /* Preselect their size; if it is sold out, preselect the NEAREST size we can ship.
       vs is the in-stock list, so this is always shippable. The nearest-size fallback is
       load-bearing now that sold-out sizes render greyed instead of being hidden: with a
       plain "first available" fallback an L customer looking at a sweatpant with no L got
       XS/S preselected, and adding a size three steps off their own is a guaranteed return. */
    var sel = vs.filter(function(v){return v.size.toUpperCase()===match;})[0];
    if(!sel){
      var mi=SIZE_ORDER.indexOf(match);
      sel = mi<0 ? vs[0] : vs.slice().sort(function(a,b){
        var da=Math.abs(SIZE_ORDER.indexOf(a.size.toUpperCase())-mi);
        var db=Math.abs(SIZE_ORDER.indexOf(b.size.toUpperCase())-mi);
        return da-db || SIZE_ORDER.indexOf(b.size.toUpperCase())-SIZE_ORDER.indexOf(a.size.toUpperCase());
      })[0];
    }
    var off=liveOff(cart,o);
    /* Price cut leads the badge when there is one. Joel 1 Aug, after testing it without:
       "they're not enticed" — a tier-unlock badge means nothing on a cart that already
       cleared every tier, and those are the carts that matter most. Money off always reads.
       Tier maths uses netAdd, never o.price, so an unlock badge can only ever appear when
       the customer genuinely lands above the threshold AFTER the discount. */
    var unlock = off ? null : unlockedBy(cart,netAdd(cart,o));

    var sizes = isOneSize ? '' :
      '<div class="olu-sizes">'+o.variants.map(function(v){
        var live = v.available && v.qty>0;
        var m = match && v.size.toUpperCase()===match && live;
        return '<button class="olu-size'+(live && v.id===sel.id?' is-sel':'')+(m?' olu-size--match':'')+
               (live?'':' is-oos')+'" data-vid="'+v.id+'" data-h="'+o.handle+'"'+
               (live?'':' disabled aria-disabled="true"')+'>'+v.size+'</button>';
      }).join('')+'</div>';

    /* Same gold badge Joel approved — only the words change. */
    var badge = off ? '<span class="olu-save">'+offerLabel(o.handle,o.price)+' OFF</span>'
                    : (unlock?'<span class="olu-save">Unlocks '+unlock.label+'</span>':'');
    /* Struck-through original next to the offer price. This is the ONLY place a marked-down
       price appears anywhere — the storefront stays full price, which is the point. */
    var priceHtml = off
      ? '<span class="olu-card__was">'+money(o.price)+'</span><span class="olu-card__now">'+money(o.price-off)+'</span>'
        +'<span class="olu-card__save">Save '+offerLabel(o.handle,o.price)+'</span>'
      : '<span class="olu-card__now">'+money(o.price)+'</span>';

    return '<div class="olu-card'+(unlock?' is-unlocker':'')+'" data-h="'+o.handle+'">'
      /* TOP ROW LOADS EAGERLY. Lazy-loading every tile meant the sheet slid up showing empty
         beige boxes for a beat while the photos fetched — Joel saw exactly that and read it as
         a broken image. On a screen that gets one second of attention, the two tiles above the
         fold must be painted when it opens. Rows below stay lazy. */
      +'<div class="olu-card__img"><img src="'+o.image+'" alt="'+o.title+'"'
      +(idx<2?' loading="eager" fetchpriority="high"':' loading="lazy"')+'>'
      +badge+'</div>'
      +'<div class="olu-card__body">'
      +'<div class="olu-card__t">'+o.title+'</div>'
      +blurb
      +'<div class="olu-card__p">'+priceHtml+'</div>'
      +sizes
      +'<button class="olu-add" data-h="'+o.handle+'" data-vid="'+sel.id+'">Add</button>'
      +'</div></div>';
  }

  function render(cart,offers){
    var match=cartSizes(cart);
    /* lead with whatever actually crosses a tier — that's both the strongest pitch and,
       per the July basket data, the only version that makes money */
    offers=offers.slice().sort(function(a,b){
      return (unlockedBy(cart,netAdd(cart,b))?1:0)-(unlockedBy(cart,netAdd(cart,a))?1:0);
    });
    grid.innerHTML=offers.map(function(o,i){ return card(o,match,cart,i); }).join('');

    var elig=eligibleCents(cart), nt=nextTier(elig);
    var anyUnlocks=offers.some(function(o){ return unlockedBy(cart,netAdd(cart,o)); });
    if(nt && anyUnlocks){
      sub.innerHTML='You\'re <b>'+money(nt.cents-elig)+'</b> away from <b>'+nt.label+'</b>. These get you there.';
    } else if(nt){
      sub.innerHTML='Add <b>'+money(nt.cents-elig)+'</b> more to unlock <b>'+nt.label+'</b>.';
    } else {
      sub.innerHTML = match
        ? 'Every reward unlocked. Showing <b>'+match+'</b> because that\'s what\'s in your bag.'
        : 'Every reward unlocked.';
    }
  }

  function refreshGoBtn(){
    var n=Object.keys(added).length;
    goTxt.textContent = n ? 'Add '+n+' + checkout' : 'Continue to checkout';
  }

  /* ---- checkout ------------------------------------------------------- */
  function go(){
    if(proceeding) return; proceeding=true;
    /* Wait on anything still in the air before reading `added`, capped so a hung request can
       never strand a customer on the offer screen. */
    var wait = inFlight.length
      ? Promise.race([ Promise.all(inFlight), new Promise(function(r){ setTimeout(r,3500); }) ])
      : Promise.resolve();
    wait.then(function(){
    var took=Object.keys(added).length>0;
    /* 6 Sep 2026 — THE SWEEP BELONGS ON THIS EXIT TOO.
       It was added to proceed() on 3 Sep because this file's own comment called that
       "the ONE funnel every checkout path goes through". It is not. go() is the OTHER
       exit — the upsell screen's "Continue to checkout" AND "No thanks, take me to
       checkout" — and it went straight to /checkout with no sweep.
       Worse: the upsell screen is SKIPPED above ~$260, so the guard was armed only on
       carts that could not have an unearned gift, and switched off on every cart that
       could. Orders #8459 and #8531 both came out this door.
       Runs alongside tagCart, capped at 2.5s inside dropUnearnedGift, and BOTH branches
       navigate — a hung sweep can never strand a customer on the offer screen. */
    var locked=false; codeApplying.then(function(){ locked=true; });
    setTimeout(function(){ if(!locked && took && offerCode) goTxt.textContent='Locking your price…'; },300);
    Promise.race([ codeApplying, new Promise(function(r){ setTimeout(r,20000); }) ]).then(function(){
      return Promise.all([ tagCart(bucket(),took,'shown'), dropUnearnedGift(), (window.olSweepOrphanUpsellCode ? window.olSweepOrphanUpsellCode() : null) /* #9262: no upsell line → OLUP code off (3 Oct) */ ]);
    }).then(function(){
      /* /discount/CODE applies it and forwards to checkout. Only ever set when a priced
         offer was actually accepted — a code on an untouched cart would be a discount for
         doing nothing. */
      window.location.href = (took && offerCode)
        ? '/discount/'+encodeURIComponent(offerCode)+'?redirect=/checkout'
        : '/checkout';
    }, function(){
      /* never strand: go to checkout even if the tag or the sweep failed */
      window.location.href = (took && offerCode)
        ? '/discount/'+encodeURIComponent(offerCode)+'?redirect=/checkout'
        : '/checkout';
    });
    });
  }

  function open(cart,offers){
    openBaseDollars = eligibleCents(cart)/100;   /* baseline for the code's minimum spend */
    markSeen();                 /* mark on OPEN, not on dismiss — a back-nav mid-screen still counts */
    render(cart,offers);
    refreshGoBtn();
    document.body.classList.add('ol-upsell-open');
    root.classList.add('is-open');
    root.setAttribute('aria-hidden','false');
  }
  function close(){
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden','true');
    document.body.classList.remove('ol-upsell-open');
  }

  /* FAIL CLOSED — the order here is the whole safety property.
     The code is minted BEFORE the item goes in the bag. If minting fails the item is never
     added and the tile says so, because the one outcome we will not ship is a customer
     accepting a price we then cannot honour at checkout.
     The line is also tagged _via:upsell. Nothing reads it today — the discount rides on the
     code — but it stamps every upsell line on the order, which is what makes take-rate and
     revenue readable straight from the Orders API. */
  function doAdd(a){
    if(a.disabled) return;
    tapCount++;
    /* Claim a slot immediately, settled in every exit path below. */
    var settle; inFlight.push(new Promise(function(res){ settle=res; }));
    var h=a.getAttribute('data-h'), vid=a.getAttribute('data-vid');
    var priced=!!CFG.offerPricing[h];
    a.disabled=true;
    var was=a.textContent;
    if(priced) a.textContent='Locking price…';

    var wanted=Object.keys(added).concat(priced?[h]:[]).filter(function(x){ return CFG.offerPricing[x]; });

    /* Nothing priced in the basket yet? No code needed — full-price adds skip the mint. */
    var step = wanted.length ? mintCode(wanted) : Promise.resolve(true);

    step.then(function(ok){
      if(priced && !ok){
        lastFail='mint:'+h;
        a.disabled=false; a.textContent=was;
        a.classList.add('is-failed');
        var c=a.closest('.olu-card'); if(c) c.classList.add('is-failed');
        a.textContent='Offer unavailable';
        setTimeout(function(){ a.textContent=was; a.classList.remove('is-failed'); if(c) c.classList.remove('is-failed'); },2600);
        return;
      }
      /* r.ok IS NOT OPTIONAL. Shopify refuses an add with 422 and a JSON error body, so
         .json() resolved happily and the old code went on to say "Added ✓" for an item that
         never entered the cart. Tick shown, customer checks out, item absent, nothing logged
         because .catch never fired. Fixed 2026-08-14. */
      return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({id:parseInt(vid,10),quantity:1,properties:{'_via':'upsell'}})})
        .then(function(r){
          if(!r.ok){
            return r.json().catch(function(){ return {}; }).then(function(err){
              throw new Error(err.description || err.message || ('add-http-'+r.status));
            });
          }
          return r.json();
        })
        .then(function(){
          added[h]=vid;
          if(priced && offerCode) codeApplying=applyCodeToCart(offerCode);   /* on the cart NOW, not at checkout */
          a.textContent='Added ✓'; a.classList.add('is-added');
          var card=a.closest('.olu-card'); if(card) card.classList.add('is-added');
          refreshGoBtn();
        });
    })
    .catch(function(e){
      /* Was silent: the button just reset and the customer had no idea it had not gone in. */
      lastFail='add:'+h;
      a.disabled=false;
      a.classList.add('is-failed');
      var c2=a.closest('.olu-card'); if(c2) c2.classList.add('is-failed');
      a.textContent='Could not add';
      setTimeout(function(){ a.textContent=was; a.classList.remove('is-failed'); if(c2) c2.classList.remove('is-failed'); },2600);
    })
    .then(function(){ settle(); }, function(){ settle(); });   /* free the checkout wait, always */
  }

  /* ---- wire ----------------------------------------------------------- */
  document.addEventListener('click',function(e){
    /* size pick */
    var s=e.target.closest('.olu-size');
    if(s){
      var card=s.closest('.olu-card');
      card.querySelectorAll('.olu-size').forEach(function(b){ b.classList.remove('is-sel'); });
      s.classList.add('is-sel');
      card.querySelector('.olu-add').setAttribute('data-vid', s.getAttribute('data-vid'));
      return;
    }
    /* add — via the button OR a tap anywhere on the tile (Joel 30 Jul: tapping the card
       did nothing, which reads broken. The whole tile is the target now; the button just
       stays as the visual affordance). */
    var a=e.target.closest('.olu-add');
    if(!a){
      var c=e.target.closest('.olu-card');
      if(c && !c.classList.contains('is-added')) a=c.querySelector('.olu-add');
    }
    if(a){ doAdd(a); return; }
    if(e.target.closest('#olUpsellGo')){ go(); return; }
    if(e.target.closest('#olUpsellSkip') || e.target.closest('#olUpsellClose')){ go(); return; }
    if(e.target===root){ go(); return; }
  });

  /* Send them on, but TAG THE CART FIRST so the order carries its bucket.
     Every path out of here must go through this — including the hold-out and every skip
     reason. If a path proceeds untagged, those orders vanish from the analysis and the
     comparison silently breaks. `why` records which path it was, so a low take rate can be
     told apart from "we never actually showed it". */
  /* ── UNEARNED GIFT SWEEP (added 2026-09-03) ──────────────────────────────
     Order #8459: ONE tee, $100 gross, $72.96 paid, and a free strap back. The gift
     is added by the cart drawer, but the drawer's giftSync() only runs from paint().
     If stripping the basket is the customer's LAST action and they never reopen the
     drawer, nothing re-checks and the gift rides all the way to checkout. The drawer
     already documents the mirror-image bug: #7807 LOST a gift for the same reason.

     proceed() is the ONE funnel every checkout path goes through (see the note above
     it), so this belongs here and nowhere else.

     Identifies the gift by its _gift line property first — that is what the drawer
     actually stamps on it (properties:{'_gift':'1'}) and it survives new gift SKUs
     being added. GIFT_VARIANTS is the fallback for anything stamped before that.

     ⚠️ IT MUST NEVER BLOCK A SALE. Any error, any slow response, and we go to
     checkout anyway — a $7.58 hat is not worth losing an order over. Hard 2.5s cap. */
  function dropUnearnedGift(){
    return new Promise(function(resolve){
      var done=false;
      function finish(){ if(!done){ done=true; resolve(); } }
      setTimeout(finish, 2500);                 /* checkout never waits on this */
      var tier=null;
      for(var i=0;i<TIERS.length;i++){ if(TIERS[i].label==='FREE GIFT') tier=TIERS[i].cents; }
      if(tier===null){ finish(); return; }
      fetch('/cart.js',{headers:{Accept:'application/json'}})
        .then(function(r){ return r.json(); })
        .then(function(cart){
          if(!cart || !cart.items){ finish(); return; }
          var paidAfter=paidAfterUpsell(cart);
          if(eligibleCents(cart) >= tier && paidAfter >= GIFT_PAID_FLOOR){ finish(); return; }   /* earned it — leave alone */
          var keys=[];
          cart.items.forEach(function(it){
            var pr = it.properties || {};
            if(String(pr._gift)==='1' || GIFT_VARIANTS.indexOf(it.variant_id)!==-1) keys.push(it.key);
          });
          if(!keys.length){ finish(); return; }
          /* 14 Sep 2026 — ONE REQUEST, AND IT OUTLIVES THE PAGE. Read this before changing it.
             Order #8675 (Sun 13 Sep: $300 of goods, took the upsell, PAID $238.50) shipped the free
             hat with _gift_why = stripped-at-checkout@paid239. The maths above was RIGHT. The
             removal never landed. This used to send the _gift_why attribute FIRST and then chain a
             /cart/change.js per gift line after it. go() navigates the moment finish() runs, and
             finish() also fires on the 2.5s cap. On a slow phone the cap won: the attribute had
             already landed, the page left for checkout, the browser cancelled the removal still in
             flight, and the order carried a log claiming a strip that never happened. Of the three
             checkout strips on 11-13 Sep, two worked; #8675 was the one that lost the race.
             NOW: a single /cart/update.js carries the removals (updates keyed by line item key)
             AND the attribute, so the log and the removal can never disagree again - both land or
             neither does. keepalive:true is the browser's own mechanism for a request that must
             finish after the page unloads, so leaving for checkout can no longer cancel it.
             The 2.5s cap is unchanged: a sale is still never held up by this sweep.
             Verified live 14 Sep before deploy: a real cart that earned the hat, this exact
             keepalive request, then an instant navigation away - on the next page the hat was gone
             AND the log was written. The hat was also pulled off #8675 by hand, in Shopify and in
             ShipStation, on Joel's call. */
          var updates={};
          keys.forEach(function(k){ updates[k]=0; });
          fetch('/cart/update.js',{method:'POST',keepalive:true,
            headers:{'Content-Type':'application/json',Accept:'application/json'},
            body:JSON.stringify({updates:updates,
              attributes:{'_gift_why':'stripped-at-checkout@paid'+Math.round(paidAfter/100)}})})
            .then(finish, finish);
        })
        .catch(finish);
    });
  }

  /* 🚨 RE-PRICE WHATEVER UPSELL ITEMS ARE ALREADY IN THE BAG (19 Sep 2026).
     proceed() used to send everyone to plain /checkout. Anyone who took an offer, left, and came
     back through "seen-recently" / "no-offers-left" checked out WITHOUT the code — or with one
     that had expired after 30 minutes — and paid $100 for a tee shown at $65. 26 of 123 upsell
     orders since 1 Aug were charged full price for the upsell item; 10 of them this way,
     including #8776 on 18 Sep. Overcharging is worse than leaking.
     Since 18 Sep every cart has exactly ONE code, derived by the worker from the cart token, so
     asking again for "the upsell items in this bag" re-finds the same code, extends it, and
     returns it. It also rebuilds `added`, so the free-gift check below counts the upsell
     discount even when this page never saw the tap. Capped: checkout never waits on it. */
  /* 🚨 THE CODE LIVES ON THE CART (19 Sep 2026). It used to be attached only on the way out,
     via /discount/CODE when our checkout button was pressed. Express pay in the drawer (Shop Pay,
     Apple Pay, Google Pay, PayPal) never presses that button, a reload forgot it, and a 30-minute
     code expired under anyone who came back later — all three charged $100 for a tee shown at
     $65. On the cart, EVERY exit carries it, and the drawer shows "YOU SAVE". Proven live 19 Sep:
     Shop Pay express checkout showed the OLUP line at -$35.
     Keeps any other code already on the cart. Checks the result and retries once: Shopify's
     storefront can take a second or two to see a code the admin API has just refreshed. */
  /* 🚨 24 Sep 2026 — A BRAND-NEW CODE CAN BE JUDGED BEFORE SHOPIFY KNOWS IT EXISTS.
     The code is minted a moment before this runs. Shopify's storefront can take a few seconds to
     see it, and if the cart evaluates it in that window it stores it as applicable:false and NEVER
     re-evaluates — /discount/CODE on the way out re-applies the same string and checkout still
     charges $100. Joel hit it on his phone (Chrome iOS = WebKit, 2 hoodies + Blue, $374.40), and it
     reproduced in WebKit with the code proven valid a minute later. The single 1.5s retry re-posted
     the identical string, which the cart treats as "no change". So: retry on a backoff, and from the
     second try BOUNCE it (post the cart without the code, then with it) to force a fresh evaluation.
     Keeps trying for ~25s. go() and proceed() wait on it (capped at 20s, button reads "Locking your
     price…") before leaving — a short wait beats charging $100 for a tee shown at $65. */
  var codeApplying=Promise.resolve(true);
  function applyCodeToCart(code){
    if(!code) return Promise.resolve(false);
    function post(list){
      return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
        body:JSON.stringify({discount:list.join(',')})}).then(function(r){ return r.json(); });
    }
    function attempt(bounce){
      return fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){ return r.json(); })
        .then(function(cart){
          var keep=(cart.discount_codes||[]).map(function(d){ return d.code; })
            .filter(function(c){ return c && !/^OLUP-/i.test(c); });
          return (bounce ? post(keep) : Promise.resolve()).then(function(){ return post(keep.concat([code])); });
        })
        .then(function(cart){
          return (cart.discount_codes||[]).some(function(d){ return d.code===code && d.applicable; });
        })
        .catch(function(){ return false; });
    }
    /* Measured 24 Sep: a new code went live on the storefront after 5.7s, 9.3s and 15.4s. */
    var waits=[0,1500,2000,2000,2500,2500,3000,3000,3000,3000,3000];
    function run(i){
      return new Promise(function(r){ setTimeout(r,waits[i]); })
        .then(function(){ return attempt(i>0); })
        .then(function(ok){ return (ok || i>=waits.length-1) ? ok : run(i+1); });
    }
    return run(0).then(function(ok){ if(!ok) lastFail='cart-code'; return ok; });
  }

  function repriceUpsells(){
    return fetch('/cart.js',{headers:{Accept:'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(cart){
        cartToken=cart.token||cartToken;
        var hs=[];
        (cart.items||[]).forEach(function(it){
          var p=it.properties||{};
          if(p._via==='upsell' && CFG.offerPricing[it.handle] && hs.indexOf(it.handle)===-1){
            hs.push(it.handle);
            if(!added[it.handle]) added[it.handle]=String(it.variant_id);
          }
        });
        if(!hs.length) return;
        return mintCode(hs).then(function(d){
          if(!d){ lastFail='reprice'; return; }
          return applyCodeToCart(d.code);
        });
      })
      .catch(function(){ lastFail='reprice'; });
  }

  function proceed(b, took, why){
    if(proceeding) return; proceeding=true;
    var reprice=Promise.race([ repriceUpsells(), new Promise(function(r){ setTimeout(r,20000); }) ]);
    /* re-price FIRST so the gift sweep sees the real price; tag + sweep stay capped and parallel */
    reprice.then(function(){ return Promise.all([ tagCart(b, took, why), dropUnearnedGift(), (window.olSweepOrphanUpsellCode ? window.olSweepOrphanUpsellCode() : null) /* #9262: no upsell line → OLUP code off (3 Oct) */ ]); })
      .then(leave, leave);
    function leave(){
      window.location.href = offerCode
        ? '/discount/'+encodeURIComponent(offerCode)+'?redirect=/checkout'
        : '/checkout';
    }
  }

  /* INTERCEPT the cart drawer's Secure Checkout */
  document.addEventListener('click',function(e){
    if(!CFG.enabled) return;               /* launch gate: normal checkout, no intercept */
    var btn=e.target.closest('.olc-checkout');
    if(!btn || proceeding) return;
    var b=bucket();
    e.preventDefault();
    /* hold-out removed 5 Aug — every customer now sees the screen. */
    if(alreadySeen()){ proceed(b,false,'seen-recently'); return; }
    fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();})
      .then(function(cart){
        cartToken=cart.token||null;
        if(cart.total_price < CFG.minCartCents){ proceed(b,false,'cart-below-min'); return; }
        var offers=pickOffers(cart);
        if(!offers.length){ proceed(b,false,'no-offers-left'); return; }
        open(cart,offers);
      })
      .catch(function(){ proceed(b,false,'error'); });
  },true);

  document.addEventListener('keyup',function(e){ if(e.key==='Escape' && root.classList.contains('is-open')) go(); });

  /* SELF-HEAL (19 Sep 2026). ⚠️ MUST live in THIS block (the one holding repriceUpsells/CFG). The
     first version was appended to the file's SECOND block, where none of that exists, and
     threw silently on every page — caught by the live test, not by a syntax check. If the connection drops between "item added" and "code on the
     cart", the item sits in the bag at full price and express pay would charge it. So on every
     page view and every time the cart is opened: an upsell item in the bag with no WORKING
     upsell code on the cart gets re-priced. One /cart.js read when nothing is wrong; it only
     mints when something is. A healing run in progress blocks a second one. */
  var healing=false;
  function ensureUpsellPriced(){
    if(!CFG.enabled || healing) return;
    healing=true;
    fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){ return r.json(); })
      .then(function(cart){
        var hasUpsell=(cart.items||[]).some(function(it){
          return (it.properties||{})._via==='upsell' && CFG.offerPricing[it.handle];
        });
        var priced=(cart.discount_codes||[]).some(function(d){ return /^OLUP-/i.test(d.code) && d.applicable; });
        if(hasUpsell && !priced) return repriceUpsells();
      })
      .catch(function(){})
      .then(function(){ healing=false; }, function(){ healing=false; });
  }
  /* Run as soon as this script starts — NOT on 'pageshow'. pageshow waits for every image on the
     page; on the tees collection that was 21 seconds, long enough to tap express pay at full
     price (measured live 19 Sep). pageshow is kept only for a back-button restore from cache,
     where the script does not start again. */
  setTimeout(ensureUpsellPriced, 250);
  window.addEventListener('pageshow', function(e){ if(e.persisted) ensureUpsellPriced(); });
  document.addEventListener('click', function(e){ if(e.target.closest('#olCartLink')) setTimeout(ensureUpsellPriced, 300); }, true);
})();


/* ═══════════════════════════════════════════════════════════
   SCROLL AFFORDANCE (added 2026-08-12)
   Joel: "you can't really tell that you can scroll it."
   Toggles .olu-has-more on the sheet while the grid has more content
   below the fold; the CSS draws the fade + chevron off that class.
   Gated on REAL overflow so it never signals content that does not
   exist — the offer list is filtered per customer, so the row count
   varies and it is re-checked whenever the grid is repopulated.
   ═══════════════════════════════════════════════════════════ */
(function(){
  var grid = document.getElementById('olUpsellGrid');
  if(!grid) return;
  var sheet = grid.closest ? grid.closest('.olu-sheet') : null;
  var root  = document.getElementById('olUpsell');
  if(!sheet) return;
  function sync(){
    if(!root || !root.classList.contains('is-open')){
      sheet.classList.remove('olu-has-more'); return;
    }
    var more = (grid.scrollHeight - grid.clientHeight - grid.scrollTop) > 8;
    sheet.classList.toggle('olu-has-more', more);
  }
  grid.addEventListener('scroll', sync, {passive:true});
  window.addEventListener('resize', sync);
  try{
    new MutationObserver(function(){ setTimeout(sync,60); }).observe(grid,{childList:true});
    if(root){ new MutationObserver(function(){ setTimeout(sync,420); })
      .observe(root,{attributes:true,attributeFilter:['class']}); }
  }catch(e){}
  sync();

})();
